/* eslint-disable react/destructuring-assignment */
import { media } from 'designsystem/index';
import Button from 'elements/Button';

const CustomButton = Button.extend`
  margin-left: ${props => (props.centered ? 'auto' : 'inherit')};
  margin-right: ${props => (props.centered ? 'auto' : 'inherit')};
   ${media.desktop`
      margin-left: ${props => (props.centered ? 'auto' : 'inherit')};
  `};
`;

export default CustomButton;



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomButton.jsx